import { DocumentNode } from 'graphql';
import { Client, OperationResult } from 'urql';

// network-only bypasses the cache, but urql can still join an older in-flight
// operation. Its result retains the originating context. Once that operation
// finishes, a second query starts (or joins) a request begun after this call.
export async function queryFresh<Data>(
  client: Client,
  query: DocumentNode,
  variables: Record<string, unknown>,
): Promise<OperationResult<Data>> {
  const requestToken = {};
  const run = (): Promise<OperationResult<Data>> =>
    client
      .query<Data>(query, variables, {
        requestPolicy: 'network-only',
        freshRequestToken: requestToken,
      })
      .toPromise();
  const result = await run();
  return result.operation.context.freshRequestToken === requestToken
    ? result
    : run();
}
